import Vue from 'vue'
import VueRouter from 'vue-router'
import foo from '../pages/foo'
import bar from '../pages/bar'
import Home from '@/home/Home'
import {Message} from 'element-ui'
import store from '@/store'
import {getToken} from "../request/token"

Vue.use(VueRouter)


const router = new VueRouter({
    routes:
        [
            /* 动态主页 */
            {
                path: '/',
                component: r => require.ensure([], () => r(require('@/views/LandingPage')), 'LandingPage')
            },
            /*发布文章，要写在分类详情、标签详情路由前面，不然首先跳转的就是它，而不会跳转发布文章*/
            {
                path: '/write/:id?',
                component: r => require.ensure([], () => r(require('@/views/publishArticle/publishArticle')), 'PublishArticle'),
                meta: {
                    requireLogin: true
                },
            },
            {
                path: '',
                name: 'Home',
                component: Home,
                children: [
                    {
                        path: '/blog',
                        component: r => require.ensure([], () => r(require('@/views/Index')), 'index')
                    },
                    /*文章归档（需写在 /:type/:id 之前）*/
                    {
                        path: '/archives',
                        component: r => require.ensure([], () => r(require('@/views/archive/ArchiveListPage')), 'ArchiveListPage')
                    },
                    {
                        path: '/archives/:year/:month',
                        component: r => require.ensure([], () => r(require('@/views/archive/ArchiveDetailPage')), 'ArchiveDetailPage')
                    },
                    /*文章分类、标签*/
                    {
                        path: '/:type/all',
                        component: r => require.ensure([], () => r(require('@/views/categoryTagList/BlogAllCategoryTag')), 'BlogAllCategoryTag')
                    },
                    /*文章详情*/
                    {
                        path: '/view/:id',
                        component: r => require.ensure([], () => r(require('@/views/articleDetail/ArticleItemDetail')), 'ArticleItemDetail')
                    },
                    /*分类详情、标签详情*/
                    {
                        path: '/:type/:id',
                        component: r => require.ensure([], () => r(require('@/views/categoryTagDetail/BlogCategoryTagDetail')), 'BlogCategoryTag')
                    },
                ],
            },
            /*登录页面*/
            {
                path: '/login',
                component: r => require.ensure([], () => r(require('@/views/Login')), 'Login')
            },
            /*注册页面*/
            {
                path: '/register',
                component: r => require.ensure([], () => r(require('@/views/Register')), 'Register')
            },

        ]
});

//重复跳转同一个router不会报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

//全局前置路由守卫。beforeEach()在初始化和每一次路由切换之前调用函数,控制用户信息的获取
router.beforeEach((to, from, next) => {
    if (getToken()) {
        //路径如果是请求的login登录页面，但是又存在token，并且有账户信息
        //证明用户登陆过，不能重复登录，则跳转到首页
        if (to.path === "/login" && store.state.phoneNumber.length)//if里面的条件永远不会生效
        {
            next({path: "/"});
        } else //跳的是登录界面，但是没有账户信息
        {
            //判断是否有账号信息，如果没有，则获取
            if (store.state.phoneNumber.length === 0) {
                //需要获取用户信息
                store.dispatch("getUserInfo").then((res) => {
                    next();
                }).catch((err) => {
                    Message({
                        type: "warning",
                        showClose: true,
                        message: "登录已过期!"
                    });
                    next({path: "/login"})
                })
            } else {
                //如果有用户信息，直接放行
                next();
            }
        }
    } else {
        /*如果去的路由的meta有requireLogin，也就是该路由需要登录，则*/
        /*to.matched则只需要给较高一级的路由添加requireLogin即可，其下的所有子路由不必添加。*/
        /*to.matched 的数组，如果在mate中有requiresAuth,那么就返回true*/
        if (to.matched.some(r => r.meta.requireLogin)) {
            Message({
                type: 'warning',
                showClose: true,
                message: '请先登录哦'
            })
        } else {
            next();
        }
    }
});
export default router

